package org.vreo.devicehub.features.core.domain.device.videoCameraConfig

/**
 * Video camera resolution. Represents video resolution with width and height.
 */
enum class CameraResolution(val width: Int, val height: Int) {
    HD(width = 1280, height = 720),
    FULL_HD(width = 1920, height = 1080),
    TWO_K(width = 2560, height = 1440),
    FOUR_K(width = 3840, height = 2160);
}